<!--  -->
<template>
  <div class="projectCenter">
    <div class="photoCover">
      <img :src="projectInfo.cover" alt="cover" />
      <ul v-if="useWhere === 1" class="suspensionCommon suspensionCross">
        <li>共{{ projectInfo.videoNum }}堂课</li>
        <li>{{ projectInfo.learnNum }}人学习</li>
      </ul>
      <ul v-if="useWhere === 2" class="suspensionCommon suspensionRight">
        <li>{{ projectInfo.learnNum }}人学习</li>
      </ul>
      <ul v-if="useWhere === 3" class="suspensionCommon suspensionRight">
        <li>共{{ projectInfo.videoNum }}堂课</li>
      </ul>
      <div class="member-flag" v-if="projectInfo.memberLevel"><img src="@/assets/img/arkHome/member-flag.png" alt="" /></div>
      <div class="member-lock" v-if="projectInfo.memberLevel&&userInfo.level!==30"><img src="@/assets/img/arkHome/member-lock.png" alt="" /></div>
    </div>
    <h3 class="ellipsis projectTitle">{{ projectInfo.title }}</h3>
    <p v-if="!subTitleHide" class="ellipsis porjectSub">{{ projectInfo.subtitle }}</p>
    <div class="ellipsis teacherName">{{ projectInfo.teacherNames }}</div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  props: {
    projectInfo: {
      type: Object,
      default: () => {},
    },
    useWhere: {
      // 使用卡片的位置 1 首页， 2详情页 3.列表页
      type: Number,
      default: 1,
    },
    subTitleHide: {
      // 是否显示副标题
      type: Boolean,
      default: false,
    },
  },
  components: {},
  data() {
    return {};
  },
  computed: {
    ...mapState(['userInfo']),

  },
  watch: {},
  methods: {},
  created() {},
  mounted() {},
  beforeCreate() {},
  beforeMount() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  activated() {},
};
</script>
<style lang="scss" scoped>
.projectCenter {
  padding-bottom: 24px;
  .photoCover {
    position: relative;
    width: 324px;
    height: 418px;
    border-radius: 16px;
    > img {
      width: 324px;
      height: 418px;
      border-radius: 16px;
    }
    .member-flag {
      position: absolute;
      top: -6px;
      right: 0;
      img {
        width: 58px;
        height: 36px;
      }
    }
    .member-lock {
      position: absolute;
      top: 0;
      left: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100%;
      img {
        width: 94px;
        height: 94px;

      }
    }
    .suspensionCross {
      position: absolute;
      right: 0;
      bottom: 0;
      left: 0;
      display: flex;
      justify-content: space-between;
      width: 324px;
      border-radius: 0 0 16px 16px;
    }
    .suspensionRight {
      position: absolute;
      right: 0;
      bottom: 0;
      width: 162px;
      border-radius: 16px 0 16px 0;
    }
    .suspensionCommon {
      height: 55px;
      padding: 0 20px;
      background: #1f202e;
      opacity: 0.6;
      li {
        color: #fff;
        font-weight: 400;
        font-size: 22px;
        line-height: 55px;
        text-align: center;
      }
    }
  }
  .projectTitle {
    width: 324px;
    height: 40px;
    margin-top: 16px;
    color: #333;
    font-weight: 500;
    font-size: 28px;
    line-height: 40px;
  }
  .porjectSub {
    width: 324px;
    padding: 8px 0;
    color: #666;
    font-weight: 400;
    font-size: 22px;
    line-height: 32px;
  }
  .teacherName {
    width: 324px;
    color: #666;
    font-weight: 400;
    font-size: 22px;
    line-height: 32px;
  }
}
</style>
